export default {
    'add-new-salary': 'Add new salary',
    'use-excel-file': 'Use excel file'
}